/**
 * Width of every tile in the dashboard tiles row (`ShiftsSection`): the shift
 * count tiles, `PromoCodesCard`, `BidNominationCard` and the loading
 * `DashboardTileSkeleton`. A fixed 192px, the Figma width; the DS
 * `OfficeDashboardTile` is fluid and leaves the width to the app. The row
 * wraps, so a tile that doesn't fit moves to the next line.
 */
export const DASHBOARD_TILE_WIDTH = 'w-48 flex-none';
